"use client";

import { Analytics } from "@vercel/analytics/react";
import { usePathname } from "next/navigation";
import { isPrivateExplanationPath } from "@/lib/explain/privacy";

export function PrivacyAwareAnalytics() {
  const pathname = usePathname();
  if (isPrivateExplanationPath(pathname)) return null;
  return <Analytics beforeSend={(event) => {
    // The script can remain installed after client-side navigation. Check every
    // event too, including returnTo-bearing sign-in URLs used during pairing.
    try {
      const url = new URL(event.url);
      if (isPrivateExplanationPath(url.pathname) || url.searchParams.get("returnTo")?.startsWith("/revit-bridge/publishers")) return null;
      return { ...event, url: url.origin + url.pathname };
    } catch { return null; }
  }} />;
}
